import React from "react";
import "./ToggleSwitch.scss";

const ToggleSwitch = ({
  name,
  register,
  label,
  labelIsComponent,
  required,
  SVG,
  disabled,
  value,
  handleChange,
}) => {
  const LabelComponent = labelIsComponent ? label : null;

  return (
    <div className="custom-toggle-switch">
      <label htmlFor={name} className="label">
        {SVG ? <SVG /> : null} {labelIsComponent ? <LabelComponent /> : label}
      </label>
      <label className="switch">
        <input
          disabled={disabled}
          type="checkbox"
          checked={value}
          onChange={() => {
            handleChange && handleChange(name);
          }}
          {...register(name, { required: required })}
        />
        <span className="slider"></span>
      </label>
    </div>
  );
};

export default ToggleSwitch;
